// Red Barn Donuts

$(window).on('load', function() {
    $("#loading_cover").hide();
});

/* 
We want to have a fixed header that includes both the announcement-bar.liquid and the header.liquid 
while at the same time having them editable seperately in the Customizer. Because of the new JSON 
formatted index, we have to do this with javascript. 
*/

$('#shopify-section-announcement-bar, #shopify-section-mini-header-bar, #shopify-section-header').wrapAll('<div id="header-combo" class="sticky" />')


// Show/Hide Mobile menu for event heaader
$( document ).ready(function() {
	
	$('.mobile-toggle-on').on('click', function(){
		$('.event-menu').show();
	});    
	$('.mobile-toggle-off').on('click', function(){
		$('.event-menu').hide();
	});
});



$( document ).ready(function() {
	$(document).on({
		mouseenter: function() {
			$('.mega-nav-cover').addClass('show');
			$('.site-header').addClass('scrolled');
		},
		mouseleave: function() {
		   $('.mega-nav-cover').removeClass('show');
		   $('.site-header').removeClass('scrolled');
		}
	}, '.megadropdown');
});

// Swiper - Collection
var collectionSwiper = new Swiper(".collectionSwiper", {

	navigation: {
	  nextEl: '.collectionSwiper-next',
	  prevEl: '.collectionSwiper-prev'
	},
	// Default parameters
	loop:true,
	slidesPerView: 'auto',
	spaceBetween: 20,
	slidesPerGroupAuto: false,
	centeredSlides: true,
	noSwipingSelector: '.btn',
	watchSlidesVisibility: true,
    watchOverflow: true,
	allowTouchMove: false
	
});



// Mobile Product Swiper
var mobileProductSwiper = new Swiper(".mobileProductSwiper", {
	scrollbar: {
		el: ".swiper-scrollbar"
	}
});

function resizeSlider(num){
	var currentSlideCount = num + 1;
	let newHeight = $('.product__media-item[data-index="' + currentSlideCount + '"] img').height();
	$('.swiper-wrapper').animate({height: newHeight}, 100, 'easeInOutQuint');

}
if($('.mobileProductSwiper').length != 0){
	resizeSlider(0);
}

mobileProductSwiper.on('slideChange', function() {
	resizeSlider(mobileProductSwiper.realIndex);
});

// Desktop Product Swiper

$('.desktopProductSwiper .gallery-thumbs .product__media:first-child').addClass('selected');

$('.desktopProductSwiper .gallery-thumbs .product__media').on('click', function(){
	var id = $(this).data('id');
	$('.desktopProductSwiper .gallery-viewer .product__media').hide();
	$('.desktopProductSwiper .gallery-viewer .product__media[data-id="'+ id +'"]').show();
	$('.desktopProductSwiper .gallery-thumbs .product__media').removeClass('selected');
	$(this).addClass('selected');

});




// Header Animations

$( document ).ready(function() {


	if($('body').hasClass('page-index')){
		var lastScrollTop = 0, delta = 5;
		$(window).scroll(function(){
			var nowScrollTop = $(this).scrollTop();
			if(Math.abs(lastScrollTop - nowScrollTop) >= delta){

				if (nowScrollTop > lastScrollTop){
					$('#header-combo').addClass('scrolled');
					$('.search-drawer').removeClass('transparency');

				} else {
					$('#header-combo').removeClass('scrolled');
					$('.search-drawer').addClass('transparency');
				}
				lastScrollTop = nowScrollTop;
				
			}
			var scrollTop = $(window).scrollTop(),
				elementOffset = 100,
				darkdistance = (elementOffset - scrollTop);
			if(darkdistance >= 0) {
				$('#header-combo').removeClass('scrolled');
			} else {
				$('#header-combo').addClass('scrolled');
			}
		});
	} else {
		$('#header-combo').addClass('scrolled');
	}
});


// Mobile Menu Function

$( document ).ready(function() {
			
	$('.mobile-toggle-on').on('click', function(){
		console.log('test');
		$('#mobile-menu').show();
		$('body').addClass('noscroll');
	});

	$('.mobile-toggle-off').on('click', function(){
		$('#mobile-menu').hide();
		$('body').removeClass('noscroll');
		
	});

	$('ul li.expander > a').on('click', function(e){
		e.preventDefault();
		if($(this).parent().hasClass('visible')){
		$(this).parent().find('ul').hide();
		$(this).parent().removeClass('visible');
		} else {
		$(this).parent().find('ul').show();
		$(this).parent().addClass('visible');
		}

	});

	$('.nav-link').on('click', function(e){
		e.preventDefault();

		$(this).next('.submenu-slide').animate({
			left: '0'
		}, 200);
		
	});
	$('.back-link').on('click', function(e){
		e.preventDefault();
		$(this).closest('.submenu-slide').animate({
			left: '100%'
		}, 200);

	});


});


// Show/Hide Search in header 
$( document ).ready(function() {
    $('.icon-search').on('click', function(){
      $('.search-drawer').addClass('slide-down-anim');
      $('.icon-close-search').show();
      $('.icon-search').hide();
	 
    });    
    $('.icon-close-search').on('click', function(){
      $('.search-drawer').removeClass('slide-down-anim');
      $('.icon-close-search').hide();
      $('.icon-search').show();
    });    
  });


function realCartCount() { //saves single item
	$.ajax({
		url: "/cart.js",
		type: "GET",
		async: false,
		dataType: "json",
		success: function(cart) {
			// Find all parent products and add them up
			var realCount = 0;
			$(cart.items).each(function(e, el) {
				if(el.properties !== null ) {
					if(el.properties._io_parent_order_group) {
				
					} else {
						realCount = realCount + el.quantity;
					}
				}
			}); 

			$('.user-cart-lockup .count-num').html(realCount);

			if(realCount == 0) {
				$('header .icon-cart.cart-full').addClass('hidden');
				$('header .icon-cart.cart-empty').removeClass('hidden');
			} else {
				$('header .icon-cart.cart-full').removeClass('hidden');
				$('header .icon-cart.cart-empty').addClass('hidden');
			}
		},
		error: function() {
			console.log("error");
		}
	});    
}

realCartCount();